import { useEffect } from "react";
import { getProvince } from "../../../../../../api/requestAxios/userInfo";
import { ErrorToast } from "../../../../../../shared";

const CityProvince = ({
    infoForm,
    handleInfoForm,
    fromPage,
    infoModel,
    setInfoModel,
    createCityList,
    validForm,
    handleValidForm

}) => {





    const changeCity = (e) => {
        e.preventDefault()
        infoForm?.cityList.forEach((item) => {
            if (item?.cityId === e.target.value) {
                infoForm.cityProvince.cityName = item?.cityName
                infoForm.cityProvince.cityId = item?.cityId
                infoModel.CityIdReservedOrReturned = item?.cityId
            }
        })
        if (infoModel.CityIdReservedOrReturned) {
            handleValidForm({ inputValidCityReservedOrReturned: true })
            // validForm.inputValidCityReservedOrReturned = true
        }
        else {
            handleValidForm({ inputValidCityReservedOrReturned: false })
            // validForm.inputValidCityReservedOrReturned = false
        }

        handleInfoForm({
            cityProvince: infoForm.cityProvince,
        })
    }

    const changeProvince = (e) => {
        e.preventDefault()

        infoForm?.provinceList.forEach((item) => {
            if (item?.provinceId === e.target.value) {
                infoForm.cityProvince.provinceName = item?.provinceName
                infoForm.cityProvince.provinceId = item?.provinceId
                infoForm.cityProvince.cityName = ''
                infoForm.cityProvince.cityId = ''
            }
        })
        if (e.target.value) {
            handleValidForm({ inputValidCityReservedOrReturned: false })
            // validForm.inputValidCityReservedOrReturned = false
        }

        handleInfoForm({
            cityProvince: infoForm.cityProvince,
        })
        createCityList(infoForm?.cityAndProvinceList, infoForm?.cityProvince)

    }


    return (
        <>
            <div className="d-flex  flex-column justify-content-between input-lbl-wrapper">
                <div className="d-flex justify-content-start align-items-center">
                    <label>استان</label>
                    {infoModel?.FactorIssueType === 2 && !infoForm?.cityProvince?.provinceId && <span className="required">*</span>}
                </div>
                <select value={infoForm?.cityProvince?.provinceId} onChange={(e) => { changeProvince(e) }}>
                    <option value="" >انتخاب کنید</option>
                    {infoForm?.provinceList.map((item, index) => {
                        return (<option key={item?.provinceId} value={item?.provinceId} >{item?.provinceName}</option>)
                    })}
                </select>
            </div>
            <div className="d-flex  flex-column justify-content-between input-lbl-wrapper">
                <div className="d-flex justify-content-start align-items-center">
                    <label>شهر</label>
                    {infoModel?.FactorIssueType === 2 && !infoForm?.cityProvince?.cityId && <span className="required">*</span>}
                </div>
                <select value={infoForm?.cityProvince?.cityId} onChange={(e) => { changeCity(e) }}>
                    <option value="" >انتخاب کنید</option>
                    {infoForm?.cityList.map((item, index) => {
                        return (<option key={item?.cityId} value={item?.cityId} >{item?.cityName}</option>)
                    })}
                </select>
            </div>
        </>
    )
}
export default CityProvince